<template>
    <section
        class="ProductCarousel my-large desk-my-xlarge"
    >
        <div class="container">
            <BaseHeading
                :preheading="subheading"
                :heading="heading"
                :tag="tag"
            />

            <FilterNav
                v-if="categories"
                :categories="categories"
                :active-filter.sync="activeFilter"
            >
                <BaseButton
                    :href="moreProductsUrl"
                    modifier="small"
                >
                    More
                </BaseButton>
            </FilterNav>
            <ProductCarouselSlides
                v-for="(cat, index) in categories"
                :key="cat + index"
                :class-object="classObject(cat)"
                :products="getFilteredItems(cat)"
            />
            <HrLine
                v-if="border"
            />
        </div>
    </section>
</template>
<script>
import ProductCarouselSlides from '@components/ProductCarouselSlides.vue'
import FilterNav from '@components/FilterNav.vue'
import HrLine from '@components/HrLine.vue'

export default {
    name: 'ProductCarousel',
    components: {
        ProductCarouselSlides,
        FilterNav,
        HrLine
    },
    props: {
        products: {
            type: Array,
            default: null
        },
        heading: {
            type: String,
            default: null
        },
        subheading: {
            type: String,
            default: null
        },
        tag: {
            type: String,
            default: 'h1'
        },
        border: {
            type: Boolean,
            default: false
        },
        moreProductsUrl: {
            type: String,
            default: '/do-and-see'
        },
    },
    data() {
        return {
            activeFilter: '',
            categoriesMap: {
                'Nature & Wildlife': {
                    label: 'Nature & Outdoors',
                    order: 1
                },
                'Outdoor Activities': {
                    label: 'Nature & Outdoors',
                    order: 1
                },
                'Eat & Drink': {
                    label: 'Eat & Drink',
                    order: 2
                },
                'Arts, Culture & Heritage': {
                    label: 'Arts, Culture & Heritage',
                    order: 3
                },
                'Tours': {
                    label: 'Tours',
                    order: 4
                }
            }
        }
    },
    computed: {
        categories: function() {
            const categories = this.products.reduce((total, curr) => {
                const category = curr.categories[0];
                const outputCategory = this.categoriesMap[category];
                const notAdded = outputCategory && total.filter((i) => i.label == outputCategory.label).length == 0;
                if (category && outputCategory && notAdded) {
                    total.push(outputCategory)
                }
                return total;
            }, [])
            return categories.sort((a, b) => a.order - b.order ).map((i) => i .label);
        },
    },
    created() {
        this.activeFilter = this.categories[0]
    },
    methods: {
        getFilteredItems(cat) {
            return this.products.filter((item) => {
                return item.categories.find((productCat) => {
                    const mappedCategory = this.categoriesMap[productCat];
                    return mappedCategory && mappedCategory.label === cat;
                });
            });
        },
        classObject(cat) {
            return {
                'is-visible': cat === this.activeFilter
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .ProductCarousel {
        overflow: hidden;
    }

    .BaseHeading {
        text-align: center;
        margin-bottom: getSpacing('medium');

        @include media-query(desk) {
            margin-bottom: getSpacing('large');
        }
    }

    .HrLine {
        padding-left: 0;
        padding-right: 0;
        margin-bottom: getSpacing('large');
        margin-top: getSpacing('medium');
    }
</style>
